import type { IOverviewEventDataOptions } from './overviewEventDataModel';

/** trend_event_list 请求体中的 form 形态（与 EventService / KPI 筛选器共用） */
export interface IOverviewEventDataFormValue {
  diff: unknown;
  timeType: string;
  filterValue: Record<string, unknown>;
}

/** 与 EventService props / KPI kpiEventDataSource 对齐 */
export interface IOverviewEventListOptionsInput {
  mergeConsecutiveTrendDays?: boolean;
  excludeEventTypes?: string[];
  removeEventNumLimit?: boolean;
  filterEventDateField?: string;
  minTrendRangeDays?: number;
}

/** 与 EventService / KPI 筛选器共用：由 filterVal 拼 useEventData 所需 form */
export function buildOverviewEventDataFormValueFromFilterVal(
  filterVal: Record<string, unknown> | undefined,
): IOverviewEventDataFormValue {
  const fv = filterVal || {};
  const { diff, timeType: rawTimeType, ...filters } = fv;
  const timeType =
    typeof rawTimeType === 'string' && rawTimeType !== ''
      ? rawTimeType
      : 'Day';
  return {
    diff,
    timeType,
    filterValue: {
      ...filters,
    },
  };
}

/** 生成 useEventData 的 options */
export function toOverviewEventDataOptions(
  cfg: IOverviewEventListOptionsInput | undefined,
): IOverviewEventDataOptions | undefined {
  if (!cfg) {
    return undefined;
  }
  const {
    mergeConsecutiveTrendDays,
    excludeEventTypes,
    removeEventNumLimit,
    filterEventDateField,
    minTrendRangeDays,
  } = cfg;
  if (
    !mergeConsecutiveTrendDays &&
    !excludeEventTypes?.length &&
    !removeEventNumLimit &&
    !filterEventDateField &&
    (typeof minTrendRangeDays !== 'number' || minTrendRangeDays <= 0)
  ) {
    return undefined;
  }
  return {
    ...(mergeConsecutiveTrendDays ? { mergeConsecutiveTrendDays: true } : {}),
    ...(excludeEventTypes?.length ? { excludeEventTypes } : {}),
    ...(removeEventNumLimit ? { removeEventNumLimit: true } : {}),
    ...(filterEventDateField ? { filterEventDateField } : {}),
    ...(typeof minTrendRangeDays === 'number' && minTrendRangeDays > 0
      ? { minTrendRangeDays }
      : {}),
  };
}
